<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Add Affiliate</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link :to="{name: 'affiliates'}">Affiliate</router-link>
      /
      <b>Add</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <!-- <div class="col-md-8 offset-md-2"> -->
        <div class="col-md-12 card mb-4">
          <div class="card-body">
            <!-- Form -->
            <div class="form-group mb-3">
              <label for="full-name">Name</label>
              <input class="form-control" type="text" v-model="name" />
            </div>

            <div class="form-group">
              <!-- <label for="contact_no">Contact</label> -->
               <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <!-- cashout at -->
                  <div class="form-group">
                    <label for="date">Mobile Number</label>
                    <input
                      class="form-control"
                      type="number"
                      v-model="mobile_number"
                    />
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="form-group">
                    <label for="payment">Office Number</label>
                    <input
                      class="form-control"
                      type="number"
                      v-model="office_number"
                    />
                  </div>
                </div>
              </div>
            </div>

            

            <div class="form-group mb-3">
              <label for="email">Email</label>
              <input class="form-control" type="email" v-model="email" />
            </div>

            <div class="form-group mb-3">
              <label for="address">Address</label>
              <input class="form-control" type="text" v-model="address" />
            </div>

            <div class="form-group mb-3">
              <label for="facebook">Facebook</label>
              <input class="form-control" type="text" v-model="facebook" placeholder="https://www.facebook.com"/>
            </div>

            <div class="form-group mb-3">
              <label for="instagram">Instagram</label>
              <input class="form-control" type="text" v-model="instagram" placeholder="https://www.instagram.com"/>
            </div>

            <div>
              <label for="status">Status</label>
              <select class="form-control" v-model="status">
                <option value="0">Inactive</option>
                <option value="1">Active</option>
              </select>
            </div>

            <!-- Button -->
            <div class="text-center mt-4">
              <button
                @click="submit()"
                class="btn btn-rounded btn-primary"
                style="width: 100px;"
              >
                Submit
              </button>
            </div>

            <loading
              :active.sync="isLoading"
              :can-cancel="false"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      name: null,
      contact_no: null,
      email: null,
      address: null,
      facebook: null,
      instagram: null,
      status: 0,
    };
  },

  methods: {
    async add() {
      let token = localStorage.getItem("token");

      if(token === null || token === '') {
        console.log('You are unauthorised')
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;

      try {
        let result = await axios.post(axios.lpsURL + "/affiliate/store", this.post_request(), {
          headers: {
            Authorization: "Bearer " + token
          }
        });

        swal({
          icon: result.data.success ? 'success' : 'error',
          text: result.data.message 
        }).then(() => {
          this.$router.go(-1);
        });

      } catch (error) {
        console.log(error);
      }
    },

    post_request() {
      return {
        name: this.name,
        mobile_no: this.mobile_number,
        office_no: this.office_number,
        email: this.email,
        address: this.address,
        facebook: this.facebook,
        instagram: this.instagram,
        status: this.status
      }
    },

    async submit() {
      this.isLoading = true;
      this.add();
      this.isLoading = false;
    },

    lps() {
      return this.$lps();
    }
  },

  mounted() {
  }
};
</script>
